// SourceMentionsZone — French. 'Open', 'not collected' already live in common.fr.ts and are not
// repeated here. Series labels render through `seriesLabel` (series.v1.ts), not this catalogue.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Named in sources': 'Nommé dans les sources',
  'Name': 'Nom',
  'Source': 'Source',
  'Category': 'Catégorie',
  'Document': 'Document',
  'Last modified': 'Dernière modification',
  'Show': 'Afficher',
  'hide': 'masquer',
  'Series': 'Séries',
  'Period': 'Période',
  'Value': 'Valeur',
}, 'SourceMentionsZone');
